<template>
  <div
    class="field-group"
    :class="[groupClass, { 'has-error': !!errorMessage }]"
  >
    <label
      v-if="label"
      :for="id"
      class="field-label"
      :class="{ required }"
    >
      {{ label }}
      <span
        v-if="helpText"
        class="help-icon"
        :title="helpText"
        >?</span
      >
    </label>

    <slot />

    <span
      v-if="errorMessage"
      class="error-text"
    >
      {{ errorMessage }}
    </span>
  </div>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: false,
  },
  helpText: {
    type: String,
    default: "",
  },
  errorMessage: {
    type: String,
    default: "",
  },
  groupClass: {
    type: [String, Object, Array],
    default: "",
  },
});
</script>

<style scoped>
.error-text {
  color: var(--vermelho);
  font-size: 0.78rem;
  margin-top: 2px;
}
</style>
